export const emailAlreadyExist = "ThisEmailAddressAlreadyExists";
export const activeUserWithEmailNotFound = "ActiveUserWithEmailNotFound";
export const codeIsInvalid = "Code is invalid";

export enum ExpiredLinkErrors {
    TokenIsNotProvided = "Token is not provided",
    UserNotFound = "User not found",
    TokenIsInvalid = "Token is invalid",
    TokenIsExpired = "Token is expired",
    TokenIsExpiredCode = "TokenIsExpired",
    ChangeEmailRequestIsExpired = "ExpiredCodeValidator",
    ChangeEmailTokenIsInvalid = "ChangeEmailTokenIsInvalid",
}

export enum CompanyDetailErrors {
    CompanyHouseNumberMustBeUnique = "CompanyHouseNumberMustBeUnique",
}

export const PERMISSION_IS_REQUIRED_ERROR_CODE = "PermissionIsRequired";
